import React from 'react';
import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { useCart } from '../../context/CartContext';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product);
  };

  return (
    <Link
      to={`/product/${product.slug}`}
      className="group flex flex-col bg-white rounded-sm overflow-hidden border border-dark-200 hover:border-athletic-500 hover:shadow-card-hover transition-all duration-300"
    >
      <div className="aspect-square bg-dark-50 relative overflow-hidden border-b border-dark-100">
        <img src={product.image} alt={product.name} loading="lazy" className="w-full h-full object-contain p-6 group-hover:scale-105 transition-transform duration-500" />
        {product.badge && (
          <span className="absolute top-0 left-0 px-3 py-1.5 text-white text-[10px] font-bold uppercase tracking-widest bg-athletic-600">{product.badge}</span>
        )}
      </div>
      <div className="p-5 flex flex-col flex-grow">
        <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-dark-400 mb-1.5">{product.categorySlug?.replace(/-/g, ' ')}</p>
        <h3 className="font-display text-lg font-bold uppercase text-dark-900 mb-2 group-hover:text-athletic-600 transition-colors line-clamp-2 leading-tight">{product.name}</h3>
        <p className="text-sm text-dark-500 line-clamp-2 mb-4 flex-grow">{product.description}</p>
        <div className="flex items-center justify-between gap-2 mt-auto">
          <span className="font-display text-2xl font-bold text-dark-900">${product.price.toFixed(2)}</span>
          <button onClick={handleAddToCart} aria-label="Add to cart" className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-sm bg-dark-900 text-white text-sm font-bold uppercase tracking-wide hover:bg-athletic-600 transition-colors">
            <Plus className="w-4 h-4" /> Add
          </button>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
